import { blueGrey } from '@material-ui/core/colors';

const styles = (theme) => ({
  root: {
    flexGrow: 1,
  },
  filterButton: {
    marginTop: '16px',
  },
  blue: {
    color: theme.palette.getContrastText(blueGrey[500]),
    backgroundColor: blueGrey[500],
    fontFamily: ['Roboto'],
  },
  marginTop: {
    marginTop: '24px',
  },
  greenChip: {
    backgroundColor: theme.palette.primary.light,
    marginRight: '8px',
    maxWidth: '100%',
  },
  blueChip: {
    backgroundColor: theme.palette.info.light,
    marginRight: '8px',
    maxWidth: '100%',
  },
  yellowChip: {
    backgroundColor: theme.palette.warning.dark,
    marginRight: '8px',
    maxWidth: '100%',
  },
  redChip: {
    backgroundColor: theme.palette.error.light,
    marginRight: '8px',
    maxWidth: '100%',
  },
});

export default styles;
